export const SCHEMA_VERSION = "0.3.0";
export const PACKAGE_VERSION = "1.0.0";
